// @ts-nocheck
import { backendReadyPromise } from '../map/data-sync';
import { openPostById } from './posts-feed';
import { hasMemorialDeepLinkParams } from './memorial-deep-link';
import { showToast } from '../components/toast/toast';
import { t } from '../i18n';

function isStripeReturn(params: URLSearchParams): boolean {
  return !!(
    params.get('session_id') ||
    params.get('success') === 'true' ||
    params.get('canceled') === 'true'
  );
}

export function parsePostDeepLinkParam(params: URLSearchParams): string | null {
  return params.get('post')?.trim() || null;
}

export function hasPostDeepLinkParam(params?: URLSearchParams): boolean {
  return parsePostDeepLinkParam(params ?? new URLSearchParams(window.location.search)) !== null;
}

export function initPostsDeepLink(): void {
  const params = new URLSearchParams(window.location.search);
  if (isStripeReturn(params)) return;
  if (hasMemorialDeepLinkParams(params)) return;

  const postId = parsePostDeepLinkParam(params);
  if (!postId) return;

  const timeoutPromise = new Promise<void>((resolve) => setTimeout(resolve, 8000));
  Promise.race([backendReadyPromise, timeoutPromise]).then(async () => {
    const ok = await openPostById(postId);
    window.history.replaceState({}, document.title, window.location.pathname);
    if (!ok) {
      showToast(t('posts.loadError'));
    }
  });
}
